import { metrics } from '@seek/metrics-js';
import { ProfileCardDescription } from '@seek/profile-base-ui';
import { useTranslations } from '@vocab/react';
import {
  Text,
  Card as BraidCard,
  Column,
  Columns,
  ButtonIcon,
  IconEdit,
} from 'braid-design-system';
import React from 'react';
import { useDispatch } from 'react-redux';

import { Card } from 'src/components/Card/Card';
import { CardAction } from 'src/components/Card/CardAction/CardAction';
import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import { SUMMARY } from 'src/components/Router';
import { SUMMARY_FORM } from 'src/reducers/forms';

import { updateRoute } from '../../../Router/actionCreators';
import { EditSummary } from '../EditSummary/EditSummary';
import { useSummary } from '../data';

import translations from './.vocab';

const to = 'summary';
const mode = 'EDIT';

export const ReadSummary = () => {
  const { t } = useTranslations(translations);
  const dispatch = useDispatch();

  const { summary, loading, error } = useSummary();
  const showLoading = Boolean(loading || error);
  const isEmpty = !showLoading && summary === '';

  const title = isEmpty
    ? t('Add personal summary')
    : t('Edit personal summary');

  const cardAction = isEmpty ? (
    <CardAction
      to={to}
      mode={mode}
      data={{ automation: 'summary-edit' }}
      actionText={t('Add summary')}
      isEmpty={isEmpty}
      analytics={{
        currentPageSectionState: 'add',
      }}
    />
  ) : undefined;

  return (
    <>
      <Card
        name="summary"
        cardAction={cardAction}
        title={t('Personal summary')}
        emptyCardText={t(
          'Add a personal summary to your profile as a way to introduce who you are.',
        )}
        isEmpty={isEmpty}
        loading={showLoading}
        loader={
          <BraidCard>
            <LoadingItem type="text" size="standard" width="large" lines={2} />
          </BraidCard>
        }
      >
        <BraidCard>
          <Columns space="small">
            <Column>
              <Text>
                <ProfileCardDescription
                  text={summary}
                  data={{
                    automation: 'summary-read-text',
                    'hj-masked': 'true',
                  }}
                />
              </Text>
            </Column>
            <Column width="content">
              <ButtonIcon
                id="editPersonalSummary"
                icon={<IconEdit />}
                variant="transparent"
                label={t('Edit summary')}
                data={{ automation: 'summary-edit' }}
                onClick={() => {
                  if (isEmpty) {
                    metrics.count('click-empty-card-add-btn', [`card:${to}`]);
                  }
                  dispatch(
                    updateRoute({
                      to,
                      mode,
                      analytics: {
                        currentPageSectionState: 'edit',
                      },
                    }),
                  );
                }}
              />
            </Column>
          </Columns>
        </BraidCard>
      </Card>
      <FormDrawer
        title={title}
        component={EditSummary}
        card={SUMMARY}
        formName={SUMMARY_FORM}
      />
    </>
  );
};
